import React from 'react';
import { handleTime } from '../handlers/timeHandler';

const TimeCompareDropdown = ({ state, updateState }) => (
  <div className="relative inline-block">
    <select
      value={state.chosenTimeCompare}
      className="appearance-none bg-transparent pr-7 pl-2 text-700 border-none outline-none text-lg"
      onChange={(e) => updateState(handleTime(state, e.target.value, true))}
    >
      <option value="" className="text-base">Past Data</option>
      <option value="day" className="text-base">1 Day Ago</option>
      <option value="week" className="text-base">1 Week Ago</option>
      <option value="month" className="text-base">1 Month Ago</option>
      <option value="3 months" className="text-base">3 Months Ago</option>
      <option value="6 months" className="text-base">6 Months Ago</option>
      <option value="year" className="text-base">1 Year Ago</option>
    </select>

    <div className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2">
      <svg
        className="w-3 h-3 text-gray-600"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 6"
        fill="currentColor"
      >
        <path d="M0 0l5 6 5-6H0z" />
      </svg>
    </div>
  </div>
);

export default TimeCompareDropdown;